import { createContext } from "react";
import { type NavigationContextProps, type NavigationProviderProps } from "./type";

export const NavigationContext = createContext<NavigationContextProps | undefined>(undefined);

export const NavigationProvider = ({ children, value }: NavigationProviderProps) => {
    return <NavigationContext.Provider value={value}>{children}</NavigationContext.Provider>;
};
